import { z } from "zod";

export interface TechniciansListResponse {
  listado: TechnicianListEntity[];
  totalPages: number;
  totalRecords: number;
}

export interface TechnicianListEntity {
  id: number;
  nombreApellido: string;
  activo: boolean;
}

export interface TechnicianDetail {
  id: number;
  nombreApellido: string;
  email: string;
  usuario: string;
  activo: boolean;
}

export const techniciansFilterSchema = z.object({
  nombreApellido: z.any().optional(),
  activo: z.any().optional(),
});

export const technicianCreationSchema = z.object({
  usuario: z.any().optional(),
  nombreApellido: z.any().optional(),
  email: z.any().optional(),
});

export const technicianUpdateSchema = z.object({
  usuario: z.any().optional(),
  nombreApellido: z.any().optional(),
  email: z.any().optional(),
  activo: z.any().optional(),
});
